import React, { useMemo, cloneElement } from "react"
import { makeStyles } from "@material-ui/core/styles"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TableRow from "@material-ui/core/TableRow"
import Toolbar from "@material-ui/core/Toolbar"
import Typography from "@material-ui/core/Typography"

const useStyles = makeStyles({
    root: {
        width: "100%",
    },
})

export default function StickyHeadTable({ extraColumns = null, ...restProps }) {
    const { isLoading, columns, rows, tableTitle } = restProps

    const classes = useStyles()

    const tableBody = useMemo(() => {
        if (isLoading)
            return (
                <TableRow>
                    <TableCell>Loading...</TableCell>
                </TableRow>
            )
        if (rows && Array.isArray(rows)) {
            if (!rows.length) {
                return <TableCell>No records</TableCell>
            }
            return rows.map((row, rowIndex) => {
                return (
                    // eslint-disable-next-line react/no-array-index-key
                    <TableRow hover role="checkbox" tabIndex={-1} key={rowIndex}>
                        {columns.map((column) => {
                            const value = row[column.id]
                            return (
                                <TableCell key={column.id} align={column.align}>
                                    {column.format && typeof value === "number" ? column.format(value) : value}
                                </TableCell>
                            )
                        })}
                        {extraColumns &&
                            extraColumns.length &&
                            extraColumns.map((extraColumn) => {
                                let actionComponent
                                if (typeof extraColumn.action === "function") {
                                    // action column is one React component
                                    const ExtraColumnActionComponentOriginal = extraColumn.action
                                    const ExtraColumnActionComponent = (props) => <ExtraColumnActionComponentOriginal {...props} />
                                    actionComponent = cloneElement(<ExtraColumnActionComponent />, {
                                        rowData: row,
                                    })
                                } else {
                                    // action column is one basic DOM return
                                    actionComponent = cloneElement(extraColumn.action, {
                                        "data-row-index": rowIndex,
                                    })
                                }

                                return (
                                    <TableCell
                                        key={extraColumn.column.id}
                                        align={extraColumn.column.align}
                                        style={{ minWidth: extraColumn.column.minWidth }}
                                    >
                                        {actionComponent}
                                    </TableCell>
                                )
                            })}
                    </TableRow>
                )
            })
        }
        return null
    }, [isLoading, rows, columns, extraColumns])

    return (
        <>
            {tableTitle && (
                <Toolbar>
                    <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
                        {tableTitle}
                    </Typography>
                </Toolbar>
            )}
            <Paper className={classes.root}>
                <TableContainer className={classes.container}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => {
                                    return (
                                        <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                            {column.label}
                                        </TableCell>
                                    )
                                })}
                                {extraColumns && extraColumns.length
                                    ? extraColumns.map((extraColumn) => (
                                          <TableCell
                                              key={extraColumn.column.id}
                                              align={extraColumn.column.align}
                                              style={{ minWidth: extraColumn.column.minWidth }}
                                          >
                                              {extraColumn.column.label}
                                          </TableCell>
                                      ))
                                    : null}
                            </TableRow>
                        </TableHead>
                        <TableBody>{tableBody}</TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </>
    )
}
